<div class="advanced-settings-container">
  @if (loading || loadingSocial) {
    <div class="loading-container">
      <app-loading></app-loading>
    </div>
  }
  @if (social) {
    <div class="settings-wrapper">
      <div class="settings-container">
        <a class="back-button m-b-30" (click)="navigateBack(social)">
          <mat-icon svgIcon="ARROW_BACK_SETTINGS"></mat-icon>
          <span class="font-xs uppercase weight-bold m-l-10 back-text">back</span>
        </a>
        <div class="border-container">
          @if (socialSettingsFormGroup) {
            <div class="settings-content" [formGroup]="socialSettingsFormGroup">
              <div class="social-header">
                <span class="advanced-title">Advanced Settings</span>
              </div>
              <div class="form-container">
                <mat-form-field>
                  <input matInput placeholder="Room Name" aria-label="Room Name" formControlName="roomName" />
                  <mat-error>Social name is required.</mat-error>
                </mat-form-field>
              </div>
              <div class="accordion">
                <mat-accordion>
                  <!-- General Settings -->
                  <mat-expansion-panel
                    hideToggle
                    expanded
                    (opened)="panelGeneralOpened = true"
                    (closed)="panelGeneralOpened = false"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <img
                          alt=""
                          role="presentation"
                          src="/assets/images/arrow_down.svg"
                          class="m-r-18 panel-indicator"
                          [class.open]="panelGeneralOpened"
                        />
                        General Settings
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-container">
                      <mat-form-field>
                        <mat-label>Music Playlist</mat-label>
                        <mat-select formControlName="playlistId" panelClass="playlist-select-panel">
                          <mat-select-trigger>{{ playlistSelectedName }}</mat-select-trigger>
                          @for (option of playlistOptions; track option) {
                            <mat-option [value]="option.playlistId" [disabled]="option.type === 1 && !option.available">
                              @if (option.type === 1 && option.available) {
                                <mat-icon
                                  class="premium"
                                  matTooltip="Premium Playlist"
                                  svgIcon="playlist_premium"
                                ></mat-icon>
                              }
                              @if (option.type === 1 && !option.available) {
                                <mat-icon
                                  class="premium-locked"
                                  matTooltip="This is a Premium playlist. Contact support@scoot.app to access this."
                                  >lock</mat-icon
                                >
                              }
                              @if (!option.type) {
                                <mat-icon class="non-premium" matTooltip="Standard Playlist">album</mat-icon>
                              }
                              {{ option.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <app-social-theme-carousel
                      [social]="social"
                      (slideChanged)="onSlide($event)"
                    ></app-social-theme-carousel>
                  </mat-expansion-panel>
                  <!-- Room Settings-->
                  <mat-expansion-panel
                    hideToggle
                    (opened)="panelParticipantOpened = true"
                    (closed)="panelParticipantOpened = false"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <img
                          alt=""
                          role="presentation"
                          src="/assets/images/arrow_down.svg"
                          class="m-r-18 panel-indicator"
                          [class.open]="panelParticipantOpened"
                        />
                        Room Settings
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>
                      A host will always have access to the full list of features and permissions, but you can designate
                      which features are available to your participants.
                    </p>
                    <p class="weight-bold">Participants in my Room can..</p>
                    <div class="flex flex-column">
                      <mat-slide-toggle formControlName="canToast" class="custom-toggle" hideIcon="true">
                        <span class="flex items-center">
                          Make a Toast
                          <img
                            src="/assets/images/help-icon.svg"
                            alt="help-icon"
                            class="m-l-24 help-icon"
                            matTooltip="Clicking the “Make a Toast” button will make the user visible and audible to everyone in the room, and will lower other participants’ volume."
                            [matTooltipPosition]="'right'"
                          />
                        </span>
                      </mat-slide-toggle>
                      <mat-slide-toggle formControlName="canConvo" class="custom-toggle" hideIcon="true">
                        <span class="flex items-center">
                          Start an Ice Breaker
                          <img
                            src="/assets/images/help-icon.svg"
                            alt="help-icon"
                            class="m-l-24 help-icon"
                            matTooltip="Clicking the “Start an Ice Breaker” button will allow the user to display a question or prompt to everyone in the room."
                            [matTooltipPosition]="'right'"
                          />
                        </span>
                      </mat-slide-toggle>
                      <mat-slide-toggle formControlName="canStartPhotoBooth" class="custom-toggle" hideIcon="true">
                        <span class="flex items-center">
                          Photo Booth
                          <img
                            src="/assets/images/help-icon.svg"
                            alt="help-icon"
                            class="m-l-24 help-icon"
                            matTooltip="The Photo Booth feature allows a user to take a sequence of photos and GIFs of their screen that they can download or share to remember their experience."
                            [matTooltipPosition]="'right'"
                          />
                        </span>
                      </mat-slide-toggle>
                      <mat-slide-toggle formControlName="canShareLink" class="custom-toggle" hideIcon="true">
                        <span class="flex items-center">
                          Share Link
                          <img
                            src="/assets/images/help-icon.svg"
                            alt="help-icon"
                            class="m-l-24 help-icon"
                            matTooltip="If you turn this off, attendees will not see the “Share Link” button in their options panel"
                            [matTooltipPosition]="'right'"
                          />
                        </span>
                      </mat-slide-toggle>
                      @if (newSideMenu) {
                        <div class="flex flex-column">
                          <mat-slide-toggle formControlName="anyoneCanPresent" class="custom-toggle" hideIcon="true">
                            <span class="flex items-center">
                              Anyone Can Present
                              <img
                                src="/assets/images/help-icon.svg"
                                alt="help-icon"
                                class="m-l-24 help-icon"
                                matTooltip="If this is turned on, all attendees will be able to present to the room from a button in their options panel"
                                [matTooltipPosition]="'right'"
                              />
                            </span>
                          </mat-slide-toggle>
                          <mat-slide-toggle formControlName="anyoneCanShare" class="custom-toggle" hideIcon="true">
                            <span class="flex items-center">
                              Anyone Can Share Screen
                              <img
                                src="/assets/images/help-icon.svg"
                                alt="help-icon"
                                class="m-l-24 help-icon"
                                matTooltip="If this is turned on, all attendees will be able to Share their screen to the room by clicking a button in their options panel"
                                [matTooltipPosition]="'right'"
                              />
                            </span>
                          </mat-slide-toggle>
                          @if (enableGroupScreenShare) {
                            <mat-slide-toggle
                              formControlName="anyoneCanShareToGroup"
                              class="custom-toggle"
                              hideIcon="true"
                            >
                              <span class="flex items-center">
                                Anyone Can Share Screen to Group
                                <img
                                  src="/assets/images/help-icon.svg"
                                  alt="help-icon"
                                  class="m-l-24 help-icon"
                                  matTooltip="If this is turned on, all attendees will be able to Share their screen to those participants in their group."
                                  [matTooltipPosition]="'right'"
                                />
                              </span>
                            </mat-slide-toggle>
                          }
                          <mat-slide-toggle
                            formControlName="anyoneCanChangeMusic"
                            class="custom-toggle"
                            hideIcon="true"
                          >
                            <span class="flex items-center">
                              Anyone Can Change Room Music
                              <img
                                src="/assets/images/help-icon.svg"
                                alt="help-icon"
                                class="m-l-24 help-icon"
                                matTooltip="If this is turned on, all attendees will have the ability to change the room music in their options panel"
                                [matTooltipPosition]="'right'"
                              />
                            </span>
                          </mat-slide-toggle>
                          <mat-slide-toggle formControlName="recordMeeting" class="custom-toggle" hideIcon="true">
                            <span class="flex items-center">
                              Record Meeting
                              <img
                                src="/assets/images/help-icon.svg"
                                alt="help-icon"
                                class="m-l-24 help-icon"
                                matTooltip="When turned on, this setting records everything in the meeting, both in the room and presentations."
                                [matTooltipPosition]="'right'"
                              />
                            </span>
                          </mat-slide-toggle>
                        </div>
                      }
                      <div>
                        <p class="weight-bold" style="margin-top: 20px">
                          The minimap, by default, will be set to its opened mode. To set a different default mode,
                          select one of the modes from below.
                        </p>
                        <mat-radio-group
                          aria-labelledby="minimap-mode-label"
                          class="flex-radio"
                          (change)="minimapModeChange($event)"
                        >
                          @for (mode of minimapModes; track mode) {
                            <mat-radio-button
                              style="width: 100%"
                              class="custom-radio"
                              [value]="mode.value"
                              [checked]="minimapMode === mode.value"
                              [disabled]="socialIsOpen"
                            >
                              {{ mode.label }}
                            </mat-radio-button>
                          }
                        </mat-radio-group>
                      </div>
                      @if (groupSizeEnabled) {
                        <div class="social-settings-slider">
                          <p class="weight-bold" style="margin-top: 20px">
                            Participants in my Room can gather in groups of...
                          </p>
                          <span class="flex">Current Group Size: {{ groupSize }}</span>
                          <mat-slider
                            class="slider"
                            aria-labelledby="group-size-slider"
                            [max]="20"
                            [min]="2"
                            [discrete]="true"
                            [disabled]="socialIsOpen"
                            #ngSlider
                            ><input
                              placeholder="slider"
                              matSliderThumb
                              [value]="groupSize"
                              (change)="
                                onGroupSizeChange({
                                  source: ngSliderThumb,
                                  parent: ngSlider,
                                  value: ngSliderThumb.value,
                                })
                              "
                              #ngSliderThumb="matSliderThumb"
                            />
                          </mat-slider>
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                  <!-- Join Settings -->
                  <mat-expansion-panel hideToggle (opened)="panelJoinOpened = true" (closed)="panelJoinOpened = false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <img
                          alt=""
                          role="presentation"
                          src="/assets/images/arrow_down.svg"
                          class="m-r-18 panel-indicator"
                          [class.open]="panelJoinOpened"
                        />
                        Join Settings
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-container">
                      <mat-form-field>
                        <mat-label>Join Settings</mat-label>
                        <mat-select formControlName="socialPermissionType" [panelWidth]="null">
                          <mat-option [value]="socialPermissionTypeEnum.PUBLIC">
                            Only users with link can join
                            <img
                              alt="help-icon"
                              class="info-icon"
                              src="../../../../assets/images/help-icon.svg"
                              [matTooltip]="'Easiest way to have users join. Anyone who has the link can join.'"
                            />
                          </mat-option>
                          <mat-option [value]="socialPermissionTypeEnum.COMPANY">
                            Only users in my Organization can join
                            <img
                              alt="help-icon"
                              class="info-icon"
                              src="../../../../assets/images/help-icon.svg"
                              [matTooltip]="
                                'Secure your social. Users must belong to your organization before joining.'
                              "
                            />
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    @if (
                      socialSettingsFormGroup.get('socialPermissionType')?.value !== socialPermissionTypeEnum.PUBLIC
                    ) {
                      <span class="private-join-warning m-b-14">
                        *This join setting will enforce participants to create a Scoot account in order to verify their
                        association to you and/ or your company
                      </span>
                    }
                    <div class="form-container flex flex-column">
                      <mat-slide-toggle
                        formControlName="anyoneCanStart"
                        (change)="onToggleAllowBeforeHost($event)"
                        class="custom-toggle"
                        hideIcon="true"
                      >
                        Allow join before host
                      </mat-slide-toggle>
                      @if (hostAdmissionEnabled) {
                        <mat-slide-toggle
                          formControlName="hostAdmitted"
                          class="custom-toggle"
                          hideIcon="true"
                          (change)="onToggleRequireHostAdmission($event)"
                        >
                          Require host admission
                          <img
                            src="/assets/images/help-icon.svg"
                            alt="help-icon"
                            class="m-l-24 help-icon"
                            matTooltip="If you enable host admission, you will not be able to allow a participant to join before the host."
                            [matTooltipPosition]="'right'"
                        /></mat-slide-toggle>
                      }
                    </div>
                  </mat-expansion-panel>
                  <!-- Alternate Hosts -->
                  @if (alternateHostsEnabled) {
                    <mat-expansion-panel
                      hideToggle
                      (opened)="panelAlternateOpened = true"
                      (closed)="panelAlternateOpened = false"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <img
                            alt=""
                            role="presentation"
                            src="/assets/images/arrow_down.svg"
                            class="m-r-18 panel-indicator"
                            [class.open]="panelAlternateOpened"
                          />
                          Alternate Hosts
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p>
                        Select other users within this account to be an alternate host for this room. Alternate hosts
                        can perform all host privileges. Alternate hosts must have a paid license to be selected.
                      </p>
                      <alternate-hosts-selector
                        (selectionChange)="onAlternateHostsChange($event)"
                        [showLicenseError]="showHostLicenseError"
                      ></alternate-hosts-selector>
                    </mat-expansion-panel>
                  }
                  <!-- Room Size -->
                  <mat-expansion-panel
                    hideToggle
                    (opened)="panelRoomSizeOpened = true"
                    (closed)="panelRoomSizeOpened = false"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <img
                          alt=""
                          role="presentation"
                          src="/assets/images/arrow_down.svg"
                          class="m-r-18 panel-indicator"
                          [class.open]="panelRoomSizeOpened"
                        />
                        Room Size
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p>
                      Select your room size. Each size has a maximum capacity of attendees. When the room is at maximum
                      capacity, attendees attempting to join can wait until a space opens up.
                    </p>
                    <mat-radio-group
                      aria-labelledby="room-size-label"
                      class="flex-radio"
                      (change)="roomSizeChange($event)"
                    >
                      @for (room of roomSizeSettings; track room) {
                        <mat-radio-button
                          style="width: 100%"
                          class="custom-radio"
                          [value]="room.value"
                          [checked]="room.checked"
                          [disabled]="socialIsOpen"
                          [aria-label]="room.label"
                        >
                          {{ room.label }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="settings-footer flex justify-center">
        <button mat-button class="sm-button" (click)="navigateBack(social)">Cancel</button>
        <button
          mat-button
          class="sm-button border-secondary bg-color-secondary text-color-white m-l-14"
          id="startSocialButton"
          data-testid="social-settings-save-btn"
          (click)="save()"
          [disabled]="showHostLicenseError"
        >
          Save Settings
        </button>
      </div>
    </div>
  }
</div>
